/**
 * **De voordeur: spel of editor, in één bundel-ingang.**
 *
 * Eén `index.html` voor allebei, want `tests/build.*.test.ts` keurt een tweede html-bestand in
 * `dist/` af. De twee imports zijn daarom dynamisch: zo blijft three.js buiten de editorchunk en
 * blijft de editor buiten de speelchunk.
 *
 * Live draait Caddy in SPA-stand, dus een onbekend pad valt terug op `index.html` en komt hier
 * binnen. `?editor=1` is de weg voor een site zonder die terugval.
 */

import { wantsEditor } from './editor/entryRoute.ts';

// `/builder` valt onder het spel: `main.ts` vraagt `wantsBuilder` zelf en haalt dan de bouwerchunk.
async function boot(): Promise<void> {
  if (wantsEditor(window.location.pathname, window.location.search)) await import('./editor/index.ts');
  else await import('./main.ts');
}

void boot();
